// eslint-disable-next-line react/prop-types
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import UserRoles from '../../../constants/userRoles';
import SubHeader from '../../Header/SubHeader';
import AdminSearch from './searchTab/AdminSearch';
import RolePermissions from './rolePermissionsTab/RolePermissions';

const menuOptions = [
  {
    index: 0,
    label: 'Search',
  },
  {
    index: 1,
    label: 'eWFM Role Permissions',
  },
];
const tabName = { eWFM: 'eWFM Role Permissions' }

const AdminManagement = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.User);
  const [selectedOptionMenu, setSelectedOptionMenu] = useState('');

  const handleSelected = (choise) => {
    setSelectedOptionMenu(choise.label);
  };

  let AdminManagementComponent = <AdminSearch />;
  if (selectedOptionMenu === tabName.eWFM) {
    AdminManagementComponent = <RolePermissions />;
  }

  console.log('AdminManagement.jsx: Current User Role:', user.Role);
  if (user.Role !== UserRoles.Admin && user.Role !== UserRoles.Owner) {
    console.log('AdminManagement.jsx: User does not have Admin access and Owner access.');
    return navigate(
      '/AccessDenied'
    );
  }

  return (
    <>
      <SubHeader
        handleSelected={handleSelected}
        options={menuOptions}
        selectedOptions={selectedOptionMenu}
      />
      {AdminManagementComponent}
    </>
  );
};

export default AdminManagement;
